
// import throat from 'throat';
// import to from 'await-to-js';
import {compose, defaultProps, withHandlers} from 'recompose';

import { withAxios } from 'op/components/auth';
import { withErrorHandling } from 'op/components/error';

export const withReportRemarks = compose(
	defaultProps({
		onChange: () => {},
	}),
	withAxios,
	withErrorHandling
);

